"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameLoaderBaseCommon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_dom_1 = __importDefault(require("react-dom"));
const hooks_1 = require("../../hooks");
const libraries_1 = require("../../libraries");
const featureFlag_1 = require("../../featureFlag");
const translations_1 = require("../../translations");
const tracker_1 = require("../../tracker");
const renderUtils_1 = require("../utils/renderUtils");
const uiInformation_1 = require("../../uiInformation");
const initializer_1 = require("../../initializer");
const frameLoaderBaseCommon = async ({ API, APITracker, libraries, basename, componentFakeLogin, componentErrorPage, componentOwnRoutes, componentDRLogin, mainRouteToRedirect, layout: Layout, microfrontendsRoutes, routesWithoutLoading, translationsConfig, featureFlagConfig, trackerConfig, developerTools, componentAssistedLogin, projectId, DynamicLoadManualStaticImpl, variant, routerType, }, Router, Routes) => {
    const initPromises = [];
    const XHRTracker = APITracker ?? API;
    if (trackerConfig) {
        await (0, tracker_1.initAllTrackers)(trackerConfig, XHRTracker, initializer_1.GenericUSDManager, initializer_1.Authenticator);
        tracker_1.trackers.tealiumTracker && initPromises.push((0, tracker_1.addCommonInfoToTealiumTracker)(trackerConfig));
        tracker_1.trackers.wrapupTracker && (0, tracker_1.addCommonInfoToWrapupTracker)(trackerConfig);
    }
    initPromises.push((0, libraries_1.initLibraries)(libraries));
    initPromises.push((0, uiInformation_1.initDeviceUUID)());
    const pushFeatureFlags = (initPromises) => {
        if (!routesWithoutLoading.includes(location?.pathname)) {
            if (featureFlagConfig) {
                featureFlagConfig.isRequiredPublicFF
                    ? initPromises.push((0, featureFlag_1.initFeatureFlagPublic)(featureFlagConfig, API))
                    : initPromises.push((0, featureFlag_1.initFeatureFlag)(featureFlagConfig, API));
            }
        }
    };
    const pushConfigAndTranslations = (initPromises) => {
        if (translationsConfig) {
            initPromises.push((0, translations_1.initConfigAndTranslations)(API, translationsConfig));
        }
    };
    try {
        pushFeatureFlags(initPromises);
        pushConfigAndTranslations(initPromises);
        await Promise.allSettled(initPromises);
    }
    catch {
        console.error('Can`t initiate feature flag or translations. Check network');
    }
    const AppWithProviders = () => ((0, jsx_runtime_1.jsx)(Router, { basename: basename, routerType: routerType, children: (0, jsx_runtime_1.jsxs)(hooks_1.GlobalLoadingProvider, { routesWithoutLoading: routesWithoutLoading, children: [developerTools, (0, jsx_runtime_1.jsx)(Layout, { children: (0, jsx_runtime_1.jsx)(Routes, { componentFakeLogin: componentFakeLogin, componentErrorPage: componentErrorPage, componentOwnRoutes: componentOwnRoutes, mainRouteToRedirect: mainRouteToRedirect, microfrontendsRoutes: microfrontendsRoutes, componentDRLogin: componentDRLogin, componentAssistedLogin: componentAssistedLogin, projectId: projectId, DynamicLoadManualStaticImpl: DynamicLoadManualStaticImpl, variant: variant }) })] }) }));
    react_dom_1.default.render((0, jsx_runtime_1.jsx)(AppWithProviders, {}), (0, renderUtils_1.getRootElement)());
};
exports.frameLoaderBaseCommon = frameLoaderBaseCommon;
//# sourceMappingURL=index.js.map